import { render, staticRenderFns } from "./step-password.vue?vue&type=template&id=31c6a84b&"
import script from "./step-password.js?vue&type=script&lang=js&"
export * from "./step-password.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports